export const shopProducts = [
  {
    id: 1,
    name: '点滴公益公益T恤',
    price: 99,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
    donation: '每售出一件捐赠10元',
    description: '100%纯棉材质，印有点滴公益Logo'
  },
  {
    id: 2,
    name: '环保帆布袋',
    price: 49,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
    donation: '每售出一件捐赠5元',
    description: '环保材质，可重复使用，减少塑料污染'
  },
  {
    id: 3,
    name: '公益保温杯',
    price: 128,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
    donation: '每售出一件捐赠15元',
    description: '304不锈钢，24小时保温保冷'
  },
  {
    id: 4,
    name: '爱心徽章套装',
    price: 39,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
    donation: '每售出一件捐赠5元',
    description: '5枚装，可别在衣服、包包上'
  },
  {
    id: 5,
    name: '公益笔记本',
    price: 68,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
    donation: '每售出一件捐赠8元',
    description: '精装本，内页采用环保纸张'
  },
  {
    id: 6,
    name: '志愿者马甲',
    price: 88,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
    donation: '每售出一件捐赠10元',
    description: '志愿者专用，带反光条，安全醒目'
  },
  {
    id: 7,
    name: '公益雨伞',
    price: 78,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
    donation: '每售出一件捐赠8元',
    description: '三折自动伞，晴雨两用'
  },
  {
    id: 8,
    name: '爱心钥匙扣',
    price: 29,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
    donation: '每售出一件捐赠3元',
    description: '金属材质，精致小巧，随身携带'
  }
];